/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Zákaznický servis v České republice`
};

const da_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Kundeservice i Danmark`
};

const de_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Kundendienst in Deutschland`
};

const en_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Customer service in France`
};

const es_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Servicio postventa en España`
};

const fr_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `SAV en France`
};

const hu_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Magyarországi vevőszolgálat`
};

const it_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Assistenza post-vendita in Italia`
};

const nl_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Klantenservice in Nederland`
};

const pl_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Serwis posprzedażowy w Polsce`
};

const pt_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Assistência pós-venda em Portugal`
};

const sv_reinsurances_after_sales_services = /** @type {(inputs: {}) => string} */ () => {
	return `Kundservice i Sverige`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_after_sales_services = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_after_sales_services(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_after_sales_services", locale)
	if (locale === "cs") return cs_reinsurances_after_sales_services(inputs)
	if (locale === "da") return da_reinsurances_after_sales_services(inputs)
	if (locale === "de") return de_reinsurances_after_sales_services(inputs)
	if (locale === "en") return en_reinsurances_after_sales_services(inputs)
	if (locale === "es") return es_reinsurances_after_sales_services(inputs)
	if (locale === "fr") return fr_reinsurances_after_sales_services(inputs)
	if (locale === "hu") return hu_reinsurances_after_sales_services(inputs)
	if (locale === "it") return it_reinsurances_after_sales_services(inputs)
	if (locale === "nl") return nl_reinsurances_after_sales_services(inputs)
	if (locale === "pl") return pl_reinsurances_after_sales_services(inputs)
	if (locale === "pt") return pt_reinsurances_after_sales_services(inputs)
	return sv_reinsurances_after_sales_services(inputs)
};
export { reinsurances_after_sales_services as "reinsurances.after_sales_services" }